import { Flex, Space } from "antd";
import { useTranslation } from "react-i18next";
import { AppButton, AppLoader } from "@/shared/Components";
import { TagsField } from "@/entities/tags-field";
import { PersonInfoCard } from "@/entities/person-info-card";
import { EditIcon } from "@/shared/icons";
import { DeleteContactButton } from "@/entities/delete-contact-button";
import { appRouterPaths } from "@/services/navigation";
import { type ContactTabsExtraProps, useContactTabsExtra } from "../model";
import styles from "./styles.module.scss";

export const ContactTabsExtra = ({
  selectedPersonId,
  handleEditMode,
  isEditMode,
  activeTab,
  setSelectedPersonId,
}: ContactTabsExtraProps) => {
  const { t } = useTranslation();
  const { state } = useContactTabsExtra(selectedPersonId);

  const { isFetching } = state;

  if (isFetching) {
    return (
      <div className={styles.loader}>
        <AppLoader />
      </div>
    );
  }

  const showControlButtons =
    activeTab === appRouterPaths.contacts.genInfo ||
    activeTab === appRouterPaths.contacts.activities;

  return (
    <Flex vertical gap={16} className={styles.root}>
      <Flex justify="flex-start" style={{ width: "100%" }} align="baseline">
        <TagsField selectedPersonId={selectedPersonId} />
        {showControlButtons && (
          <Space style={{ marginLeft: "auto" }}>
            <AppButton
              icon={<EditIcon />}
              onClick={handleEditMode}
              className={styles["edit-btn"]}
              type="text"
            >
              {t(isEditMode ? "common.cancel" : "common.edit")}
            </AppButton>
            <DeleteContactButton
              selectedContactId={selectedPersonId}
              setSelectedPersonId={setSelectedPersonId}
            />
          </Space>
        )}
      </Flex>
      <PersonInfoCard
        personId={selectedPersonId}
        isEditMode={isEditMode}
        setIsEditMode={handleEditMode}
      />
    </Flex>
  );
};
